/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/down-the-whole.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/down-the-whole.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/down-the-whole.mdx';

const metadata = {
  slug: "down-the-whole",
  title: "DTW: Down the Whole",
  author: "Christian Battaglia",
  description: "What does it mean to go \"down the whole\"? Not just down the rabbit hole — down the whole pie. A manifesto for deep conversation, work-life balance, shower optimization, and the forum I've always wanted to build.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/2019-06-11_down-the-whole.jpg",
  date: "2019-06-11T00:00:00.000Z",
  
  readTime: "7 min read",
  tags: ["philosophy","introspection","deep thinking","Socratic method","work-life balance","habits","optimization","DTW","community"],
};

export const Route = createFileRoute('/blog/posts/down-the-whole')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/down-the-whole',
    image: '/og/blog/down-the-whole.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
